import { sendRequest, sendRequestProtocols } from "../axios";

export default {
  state: {
    calcUserManagementSettingsTab: 0,
    organisationsUM: [],
    currentOrganisationUM: null,
    currentOrganisationUserUM: null,
    usersUM: [],
    rolesUM: [],
    organisationDataByINN: null,
    currentOrganizationIDUM: null,
    usersForOperator: [],

    orgShortName: "",
    orgName: "",
    ogrn: "",
    kpp: "",
    address: "",
    directorName: "",
    directorDolgn: "",
    addressDetailed: "",
    okato: "",
    oktmo: "",
    organisationUsersUM: [],
    agentFirmSotrs: []
  },
  mutations: {
    SET_OKATO(state, commit) {
      state.okato = commit;
    },
    SET_OKTMO(state, commit) {
      state.oktmo = commit;
    },
    SET_ADDRESS_DETAILED(state, commit) {
      state.addressDetailed = commit;
    },
    SET_CURRENT_ORG_DIRECTOR_DOLGN(state, commit) {
      state.directorDolgn = commit;
    },
    SET_CURRENT_ORG_DIRECTOR_NAME(state, commit) {
      state.directorName = commit;
    },

    SET_USERS_OPERATOR(state, commit) {
      state.usersForOperator = commit;
    },
    SET_CURRENT_ORGANISATION_ID_UM(state, commit) {
      state.currentOrganizationIDUM = commit;
    },
    SET_AGENT_FIRM_SOTRS(state, commit) {
      state.agentFirmSotrs = commit;
    },
    SET_ORG_NAME(state, commit) {
      state.orgName = commit;
    },
    SET_ORG_ADDRESS(state, commit) {
      state.address = commit;
    },
    SET_CURRENT_ORGANISATION_USER_UM(state, commit) {
      state.currentOrganisationUserUM = commit;
    },
    SET_CURRENT_ORGANISATION_USERS_UM(state, commit) {
      state.organisationUsersUM = commit;
    },

    SET_CURRENT_ORG_NAME_UM(state, commit) {
      state.orgShortName = commit;
      if (state.currentOrganisationUM != null) {
        state.currentOrganisationUM["orgShortName"] = commit;
      }
    },
    SET_CURRENT_ORG_LONGNAME_UM(state, commit) {
      state.orgName = commit;
      if (state.currentOrganisationUM != null) {
        state.currentOrganisationUM["orgName"] = commit;
      }
    },
    SET_CURRENT_ORG_OGRN_UM(state, commit) {
      state.ogrn = commit;
      if (state.currentOrganisationUM != null) {
        state.currentOrganisationUM["ogrn"] = commit;
      }
    },
    SET_CURRENT_ORG_KPP_UM(state, commit) {
      state.kpp = commit;
      if (state.currentOrganisationUM != null) {
        state.currentOrganisationUM["kpp"] = commit;
      }
    },
    SET_CURRENT_ORG_ADDRESS_UM(state, commit) {
      state.address = commit;
      if (state.currentOrganisationUM != null) {
        state.currentOrganisationUM["address"] = commit;
      }
    },

    SET_ORGANISATION_BY_INN(state, commit) {
      state.organisationDataByINN = commit;
    },
    SET_CURRENT_ORGANISATION_UM(state, commit) {
      state.currentOrganisationUM = commit;
    },

    SET_USER_MANAGEMENT__SETTINGS_TAB(state, commit) {
      state.calcUserManagementSettingsTab = commit;
    },
    SET_ORGANISATIONS_UM(state, commit) {
      state.organisationsUM = commit;
    },
    SET_USERS_UM(state, commit) {
      state.usersUM = commit;
    },
    SET_ROLES_UM(state, commit) {
      state.rolesUM = commit;
    }
  },
  actions: {
    async checkInnFromIFNS({ commit }, inn) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequestProtocols(`checkInnFromIFNS/${inn}`, "get").then(
          res => {
            commit("SET_PROCESSING", false);
            resolve(res);
          }
        );
      });
    },
    FillByINN({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        // const formData = new FormData();
        // formData.append("inn", data.inn);

        sendRequestProtocols(
          `dadata/companiesInfoByInn/${data.inn}`,
          "get",
          undefined,
          () => {
            sendRequestProtocols(
              `gosebase/companiesInfoByInn/${data.inn}`,
              "get",
              undefined,
              e => {
                reject(e);
              }
            ).then(res => {
              resolve({ status_api: "gosebase", data: res.data });
            });
          }
        ).then(response => {
          resolve({ status_api: "dadata", data: response.data });
        });
      });
    },

    addUserOfFirm({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(
          "api/auth/registerUserByAdminPanel",
          "post",
          data,
          reject
        ).then(response => {
          commit("SET_PROCESSING", false);
          commit("SET_ERROR_API", response.data.error);
          commit("SET_CURRENT_ORGANISATION_USERS_UM", response.data.users);
          resolve(response);
        });
      });
    },
    addUserOfFirm2({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(
          "api/auth/registerUserByAdminPanel2",
          "post",
          data,
          reject
        ).then(response => {
          commit("SET_PROCESSING", false);
          commit("SET_ERROR_API", response.data.error);
          commit("SET_AGENT_FIRM_SOTRS", response.data.users);
          resolve(response);
        });
      });
    },

    saveCurrentOrganisationUM({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/saveAgentFirmByID", "post", data).then(response => {
          commit("SET_PROCESSING", false);
          commit("SET_ERROR_API", response.data.error);
          resolve(response);
        });
      });
    },

    updateCurrentOrganisationUM({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/updateAgentFirmByID", "post", data).then(response => {
          commit("SET_PROCESSING", false);
          commit("SET_ERROR_API", response.data.error);
          resolve(response);
        });
      });
    },
    getOrganisationUM({ commit }, data) {
      commit("SET_PROCESSING", true);
      commit("SET_CURRENT_ORGANISATION_UM", data);
      commit("SET_PROCESSING", false);
    },
    getOrganisationUserUM({ commit }, data) {
      commit("SET_PROCESSING", true);
      commit("SET_CURRENT_ORGANISATION_USER_UM", data);
      commit("SET_PROCESSING", false);
    },

    ChangeTabUM({ commit }, data) {
      commit("SET_USER_MANAGEMENT__SETTINGS_TAB", data);
    },

    getUsersOfOrganisation({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/getUsersOfOrganisation", "post", data, reject).then(
          response => {
            commit("SET_PROCESSING", false);
            commit("SET_CURRENT_ORGANISATION_USERS_UM", response.data.users);
            commit("SET_CURRENT_ORGANISATION_ID_UM", data.id);

            resolve(response);
          }
        );
      });
    },

    getUsersForOperatorPanel({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/getUsersForOperatorPanel", "get").then(response => {
          commit("SET_ORGANISATIONS_UM", response.data.firms);
          commit("SET_USERS_OPERATOR", response.data.users);
          //commit("SET_ROLES_UM", response.data.roles);

          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },

    GetUserManagementSettings({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/GetUserManagementSettings", "get").then(response => {
          commit("SET_ORGANISATIONS_UM", response.data.firms);
          commit("SET_USERS_UM", response.data.users);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    getAgentSorts({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/getAgentSorts", "get").then(response => {
          commit("SET_PROCESSING", false);
          commit("SET_AGENT_FIRM_SOTRS", response.data.users);

          resolve(response.data);
        });
      });
    },
    updateAgentSorts({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/updateAgentSorts", "post", data).then(response => {
          commit("SET_ERROR_API", response.data.message);
          commit("SET_PROCESSING", false);
          commit("SET_AGENT_FIRM_SOTRS", response.data.users);
          resolve(response);
        });
      });
    },

    updateUserManagementFirmSotr({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/updateUserManagementFirmSotr", "post", data).then(
          response => {
            commit("SET_ERROR_API", response.data.message);
            commit("SET_PROCESSING", false);
            commit("SET_AGENT_FIRM_SOTRS", response.data.users);
            resolve(response);
          }
        );
      });
    },

    deleteAgentSorts({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/deleteAgentSorts/" + data, "delete").then(response => {
          commit("SET_ERROR_API", response.data.message);
          commit("SET_PROCESSING", false);
          commit("SET_AGENT_FIRM_SOTRS", response.data.users);
          resolve(response);
        });
      });
    },
    changePasswordUserOfFirmAnon({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(
          "api/changePasswordUserOfFirmAnon",
          "post",
          data,
          reject
        ).then(response => {
          commit("SET_ERROR_API", response.data.message);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    changePasswordUserOfFirm({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/changePasswordUserOfFirm", "post", data, reject).then(
          response => {
            commit("SET_ERROR_API", response.data.message);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    }
  },
  getters: {
    GetUserManagementSettingsTab: state => state.calcUserManagementSettingsTab,
    GetOrganisationsUM: state => state.organisationsUM,
    GetCurrentOrganisationsUM: state => state.currentOrganisationUM,
    GetCurrentOrganisationsDataByINNUM: state => state.organisationDataByINN,
    GetOrganisationUsersUM: state => state.organisationUsersUM,
    GetUsersUM: state => state.usersUM,
    GetUsersOperator: state => state.usersForOperator,
    GetCurrentOrganisationUserUM: state => state.currentOrganisationUserUM,
    getOrgNameRegister: state => state.orgName,
    getOrgShortNameRegister: state => state.orgShortName,
    getOrgKPPRegister: state => state.kpp,
    getOrgOGRNRegister: state => state.ogrn,
    getAddressRegister: state => state.address,
    getAgentFirmSorts: state => state.agentFirmSotrs,
    getOrgDirectorRegister: state => state.directorName,
    getOrgDirectorDolgnRegister: state => state.directorDolgn,
    getAddressDetailed: state => state.addressDetailed,
    GetCurrentOrganisationIDUM: state => state.currentOrganizationIDUM,
    getOKATO: state => state.okato,
    getOKTMO: state => state.oktmo
  }
};
